import Vue from "vue";

let isSetupDone = false;

const state = Vue.observable({
  isOnline: false,
  offlineAt: null,
  downlink: undefined,
  downlinkMax: undefined,
  effectiveType: undefined,
  saveData: undefined,
  type: undefined
});

function updateConnectionProperties() {
  state.isOnline = window.navigator.onLine;
  state.offlineAt = state.isOnline ? null : new Date();
  // skip for non supported browsers.
  if (!("connection" in window.navigator)) {
    return;
  }

  state.downlink = window.navigator.connection.downlink;
  state.downlinkMax = window.navigator.connection.downlinkMax;
  state.effectiveType = window.navigator.connection.effectiveType;
  state.saveData = window.navigator.connection.saveData;
  state.type = window.navigator.connection.type;
  isSetupDone = true;
}

let onOnline;
let onOffline;
const onChange = () => updateConnectionProperties();

function addListeners() {
  onOffline = () => {
    state.isOnline = false;
    state.offlineAt = new Date();
  };

  onOnline = () => {
    state.isOnline = true;
  };

  window.addEventListener("offline", onOffline);
  window.addEventListener("online", onOnline);
  if ("connection" in window.navigator) {
    window.navigator.connection.onchange = onChange;
  }
}

export default {
  functional: true,
  render(_, { scopedSlots }) {
    const children = scopedSlots.default(state);

    if (!isSetupDone) {
      updateConnectionProperties();
      addListeners();
    }

    return children;
  }
};

export const networkState = () => state